import { Form } from "react-bootstrap";

const EightStepMobile = ({eightStep, updateMultipleValues}) => {

    const handleChange = (e) => {
        const values = {...eightStep};
        
        if (e.target.type === "radio") {
            values[e.target.id] = e.target.value;
        }
        else if (e.target.type === "checkbox"){
            if (e.target.checked) {
                if (values[e.target.id]?.length && values[e.target.id]?.length !== 0) {
                    
                    values[e.target.id].push(e.target.value);
                }
                else {
                    values[e.target.id] = [];
                    values[e.target.id].push(e.target.value);
                }
            }
            else {
                let index = values[e.target.id].indexOf(e.target.value);
                if (index !== -1) {
                    values[e.target.id].splice(index, 1);
                }
            }
        }
        else {
            values[e.target.id] = e.target.value;
        }
        
        updateMultipleValues({eightStep: values});
    }
    return (
      <>
        <div className="first-step-mobile-main-container mx-auto position-relative"  onChange={(e) => handleChange(e)}>
        <div className="title mb-4">
            <h1 className="register-text" style={{fontSize: 24, marginBottom: 15}}>Concluding questions</h1>
            <Form.Group controlId="formRoleName">
                <Form.Label className="form-label-mobile">What are your main motives to participate in this course? *</Form.Label>
                <Form
                    onSubmit={(e) => console.log("handle submit")}
                    style={{fontSize: 14, textAlign: "left" }}
                >
                <Form.Check // prettier-ignore
                    value={"Academic opportunities"}
                    type={"checkbox"}
                    id={`general_participation_motives`}
                    label={`Academic opportunities`}
                    name="group1"
                    checked={eightStep?.general_participation_motives?.includes('Academic opportunities')}
                />
                <Form.Check // prettier-ignore
                    value={"Experiencing different cultures"}
                    type={"checkbox"}
                    id={`general_participation_motives`}
                    label={`Experiencing different cultures`}
                    name="group1"
                    checked={eightStep?.general_participation_motives?.includes('Experiencing different cultures')}
                />
                <Form.Check // prettier-ignore
                    value={"Career advancement"}
                    type={"checkbox"}
                    id={`general_participation_motives`}
                    label={`Career advancement`}
                    name="group1"
                    checked={eightStep?.general_participation_motives?.includes('Career advancement')}
                />
                <Form.Check // prettier-ignore
                    value={"Quality of education"}
                    type={"checkbox"}
                    id={`general_participation_motives`}
                    label={`Quality of education`}
                    name="group1"
                    checked={eightStep?.general_participation_motives?.includes('Quality of education')}
                />
                <Form.Check // prettier-ignore
                    value={"Personal motives"}
                    type={"checkbox"}
                    id={`general_participation_motives`}
                    label={`Personal motives`}
                    name="group1"
                    checked={eightStep?.general_participation_motives?.includes('Personal motives')}
                />
                <Form.Check // prettier-ignore
                    value={"Other"}
                    type={"checkbox"}
                    id={`general_participation_motives`}
                    label={`Other, namely`}
                    name="group1"
                    checked={eightStep?.general_participation_motives?.includes('Other')}
                />{eightStep["general_participation_motives"]?.includes("Other") && <Form.Control
                placeholder="Please type"
                // value={summary}
                required
                id="general_participation_motives_other"
                // onChange={(e) => setSummary(e.target.value)}
            />}
                </Form>
                <Form.Control.Feedback type="invalid">
                    Please provide a title.
                </Form.Control.Feedback>
            </Form.Group>
            <Form.Group controlId="formRoleName">
                <Form.Label className="form-label-mobile">What are you most satisfied with regarding the course? *</Form.Label>
                <Form
                    onSubmit={(e) => console.log("handle submit")}
                    style={{fontSize: 14, textAlign: "left" }}
                >
                <Form.Check // prettier-ignore
                    value={`The set-up/design`}
                    type={"checkbox"}
                    id={`general_satisfaction_aspects`}
                    label={`The set-up/design`}
                    name="group2"
                    checked={eightStep?.general_satisfaction_aspects?.includes('The set-up/design')}
                />
                <Form.Check // prettier-ignore
                    value={`The learning materials`}
                    type={"checkbox"}
                    id={`general_satisfaction_aspects`}
                    label={`The learning materials`}
                    name="group2"
                    checked={eightStep?.general_satisfaction_aspects?.includes('The learning materials')}
                />
                <Form.Check // prettier-ignore
                    value={`The learning activities`}
                    type={"checkbox"}
                    id={`general_satisfaction_aspects`}
                    label={`The learning activities`}
                    name="group2"
                    checked={eightStep?.general_satisfaction_aspects?.includes('The learning activities')}
                />
                <Form.Check // prettier-ignore
                    value={`The support of teachers`}
                    type={"checkbox"}
                    id={`general_satisfaction_aspects`}
                    label={`The support of teachers`}
                    name="group2"
                    checked={eightStep?.general_satisfaction_aspects?.includes('The support of teachers')}
                />
                <Form.Check // prettier-ignore
                    value={`The assessment(s)`}
                    type={"checkbox"}
                    id={`general_satisfaction_aspects`}
                    label={`The assessment(s)`}
                    name="group2"
                    checked={eightStep?.general_satisfaction_aspects?.includes('The assessment(s)')}
                />
                <Form.Check // prettier-ignore
                    value={`The lectures`}
                    type={"checkbox"}
                    id={`general_satisfaction_aspects`}
                    label={`The lectures`}
                    name="group2"
                    checked={eightStep?.general_satisfaction_aspects?.includes('The lectures')}
                />
                <Form.Check // prettier-ignore
                    value={`The content`}
                    type={"checkbox"}
                    id={`general_satisfaction_aspects`}
                    label={`The content`}
                    name="group2"
                    checked={eightStep?.general_satisfaction_aspects?.includes('The content')}
                />
                <Form.Check // prettier-ignore
                    value={`Interaction with students`}
                    type={"checkbox"}
                    id={`general_satisfaction_aspects`}
                    label={`Interaction with students`}
                    name="group2"
                    checked={eightStep?.general_satisfaction_aspects?.includes('Interaction with students')}
                />
                <Form.Check // prettier-ignore
                    value={`Other`}
                    type={"checkbox"}
                    id={`general_satisfaction_aspects`}
                    label={`Other, namely`}
                    name="group2"
                />{eightStep["general_satisfaction_aspects"]?.includes("Other") && <Form.Control
                placeholder="Please type"
                required
                id="general_satisfaction_aspects_other"
            />}
                </Form>
                <Form.Control.Feedback type="invalid">
                    Please provide a title.
                </Form.Control.Feedback>
            </Form.Group>
            <Form.Group controlId="formRoleName">
                <Form.Label className="form-label-mobile">Please explain what you liked or disliked from the course.</Form.Label>
                <Form.Control
                    placeholder=""
                    // value={summary}
                    required
                    // onChange={(e) => setSummary(e.target.value)}
                    as={"textarea"}
                    id="general_likes_dislikes"
                    value={eightStep?.general_likes_dislikes}
                />
                <Form.Control.Feedback type="invalid">
                    Please provide a description.
                </Form.Control.Feedback>
            </Form.Group>
            <Form.Group controlId="formRoleName">
            <Form.Label className="form-label-mobile">Would you advise other exchange students to join this course? *</Form.Label>
                <Form
                    onSubmit={(e) => console.log("handle submit")}
                    style={{fontSize: 14, textAlign: "left" }}
                >
                <Form.Check // prettier-ignore
                    value={`Yes`}
                    type={"radio"}
                    id={`general_would_recommend`}
                    label={`Yes`}
                    name="group2"
                    checked={eightStep?.general_would_recommend?.includes('Yes')}
                />
                <Form.Check // prettier-ignore
                    value={`No`}
                    type={"radio"}
                    id={`general_would_recommend`}
                    label={`No`}
                    name="group2"
                    checked={eightStep?.general_would_recommend?.includes('No')}
                />
                <Form.Check // prettier-ignore
                    value={`Not Sure`}
                    type={"radio"}
                    id={`general_would_recommend`}
                    label={`Not Sure`}
                    name="group2"
                    checked={eightStep?.general_would_recommend?.includes('Not Sure')}
                />
                <Form.Check // prettier-ignore
                    value={`Other`}
                    type={"radio"}
                    id={`general_would_recommend`}
                    label={`Other, namely`}
                    name="group2"
                    checked={eightStep?.general_would_recommend?.includes('Other')}
                />{eightStep["general_would_recommend"] === "Other" && <Form.Control
                placeholder="Please type"
                required
                id="general_would_recommend_other"
            />}
                </Form>
            </Form.Group>
            <Form.Group controlId="formRoleName">
                <Form.Label className="form-label-mobile">Please explain why you would or wouldn’t advise other exchange students to join this course. *</Form.Label>
                <Form.Control
                    placeholder=""
                    // value={summary}
                    required
                    // onChange={(e) => setSummary(e.target.value)}
                    as={"textarea"}
                    id="general_recommendation_explanation"
                    value={eightStep?.general_recommendation_explanation}
                />
                <Form.Control.Feedback type="invalid">
                    Please provide a description.
                </Form.Control.Feedback>
            </Form.Group>
        </div>
      </div>
      </>
    );
  };
  
  export default EightStepMobile;
  